<template>
  <v-dialog v-model="dialogOpen" width="500" @click:outside="close">
    <v-card>
      <v-card-title>Pre-allocate Number</v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field dense label="Number" :error-messages="numberErrors" outlined :hide-details="numberErrors.length===0" v-model="number"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small :loading="getPreAllocateNumberLoading" :disabled="getPreAllocateNumberLoading" @click="submit">SAVE</v-btn>
        <v-btn color="primary" small outlined :disabled="getPreAllocateNumberLoading" @click="close">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import { validationMixin } from "vuelidate";
  import { required,numeric  } from "vuelidate/lib/validators";

  const startsWithNums = (value) => {
    return /^(01|02)/.test(value);
  }

  const isCorrectLength = (value) => {
    return value.length===10||value.length===11;
  }

  export default {
    props: ['dialogOpen'],

    data() { 
      return { 
        number: ''
      } 
    },

    mixins: [validationMixin],

    validations: {
      number: { required,numeric,isCorrectLength,startsWithNums },
    },

    computed: {
      ...mapGetters('products', ['getCurrentProduct']),
      ...mapGetters('numbers', ['getPreAllocateNumberLoading', 'getPreAllocateNumberError']),

      numberErrors() {
        const errors = [];
        if (!this.$v.number.$dirty) return errors;
        !this.$v.number.required && errors.push("This is a required field");
        !this.$v.number.numeric && errors.push("This field must be numeric");
        !this.$v.number.isCorrectLength && errors.push("This number must be between 10 & 11 digits");
        !this.$v.number.startsWithNums && errors.push("This number must start with either '01' or '02'");
        return errors;
      },
    },

    methods: {
      ...mapActions('numbers', ['preAllocateNumber']),
      ...mapActions('products', ['fetchProductNumbers']),

      async submit() {
        this.$v.$touch();

        if (!this.$v.$invalid) {
          await this.preAllocateNumber({pid: this.getCurrentProduct.id, number: {number:this.number}});

          if (!this.getPreAllocateNumberError) {
            this.fetchProductNumbers(this.getCurrentProduct.id);
            this.close();
          }
        }
      },
      
      close() {
        this.number = '';
        this.$v.$reset();
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
